import React, { useState } from 'react';
import "./Card.css";
import { SlLocationPin } from "react-icons/sl";
import { FaPhoneAlt } from "react-icons/fa";
import picCard from "../../../../Data/food.jpg";
import BenefitsPopUp from '../BenefitsPopUp/BenefitsPopUp';

// Card component to display business info
function Card({data}) {

    // State to toggle the branch details section
    const [showLocationsDetails, setShowLocationsDetails] = useState(false);
    // State to control the visibility of the benefits PopUp
    const [showBenefitsPopUp, setShowBenefitsPopUp] = useState(false);

    // Check if there are valid location addresses
    const hasLocations = Array.isArray(data.address) && data.address.length > 0;
    
    const oneLocation = data.address.length === 1;

    // Function to render location (branches) details and phone number
    const renderLocationDetails = () => {
        const locations = data.businessInformation?.address || [];
        const phone = data.businessInformation?.phone;

        if (locations.length === 0) {
            return (
                <div className="locations-details" dir="rtl">
                    <h3>🛍️ כל השירותים שלנו זמינים אונליין</h3>
                </div>
            );
        }
        return (
            <div className="locations-details" dir="rtl">
                <div className="locations-details-list">
                    {locations.map((loc, index) => (
                        <div key={index} className="location-details-text">
                            <div className="location-item">
                                <SlLocationPin className="location-icon" />
                                <span className="location-address">
                                    {loc.split(',').map((part, i) => (
                                        <React.Fragment key={i}>
                                            {part.trim()}
                                            <br />
                                        </React.Fragment>
                                    ))}
                                </span>
                            </div>
                            {phone && (
                                <div className="phone-item">
                                    <FaPhoneAlt className="phone-icon" />
                                    <span className="phone-number">{phone}</span>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    // Main render of the Card component
    return (
        <>
            <div className='business-card'>

                {/* Top section: business image and description  */}
                <div className="business-card-content" dir="rtl">
                    <div className="business-image">
                        <img
                            src={data.smallLogoUrl || picCard}
                            alt={data.name || "Business logo picture "}
                        />
                    </div>
                    <div className="business-details">
                        <h3 className="business-name">{data.name || ""}</h3>
                        {data.description ? (
                            <p className="business-description">{data.description}</p>
                        ) : (
                            <p className="no-description">{data.name}</p>
                        )}

                    </div>
                </div >

                {/* Buttons section: locations and benefits */}
                <div className="business-card-buttons">
                    <button
                        className="card-button benefits"
                        onClick={() => setShowBenefitsPopUp(true)} >
                        הטבות
                    </button>
                    {hasLocations ? (
                        <button
                            className="card-button location"
                            onClick={() => setShowLocationsDetails(!showLocationsDetails)}
                        >
                            {oneLocation ? "סניף" : "סניפים"}
                        </button>
                    ) : (
                        <button className="card-button location disabled" disabled>
                            עובדים דרך האתר🛍️
                        </button>
                    )}

                </div>

                {/* Conditionally render the branch details section */}
                {showLocationsDetails && renderLocationDetails()}
            </div>

            {/* Benefits modal popup */}
            <BenefitsPopUp
                isOpen={showBenefitsPopUp}
                onClose={() => setShowBenefitsPopUp(false)}
                data ={data}
            />

        </>
    );
}

export default Card;
